export interface QuizActionModelInput {
  isReview: boolean
  canResubmit: boolean
  isTestMode: boolean
  isCurrentSubmitted: boolean
}

export interface QuizActionModel {
  /** test 모드 제출 상태에서 "답 수정하기" 버튼 노출 여부 */
  showEditButton: boolean
  /** QuizRenderer 내장 제출 버튼 숨김 여부 */
  hideBuiltinSubmit: boolean
  /** 완료 액션 시 completeSession API 호출을 건너뛸지 (리뷰에서는 건너뜀) */
  skipCompleteApi: boolean
}

export function quizActionModel(i: QuizActionModelInput): QuizActionModel {
  const showEditButton = i.isTestMode && i.isCurrentSubmitted && (!i.isReview || i.canResubmit)
  const hideBuiltinSubmit = i.isTestMode && i.isCurrentSubmitted
  const skipCompleteApi = i.isReview
  return { showEditButton, hideBuiltinSubmit, skipCompleteApi }
}
